/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

const PREFIX = 'WidgetButton';

const classes = {
  border: `${PREFIX}-border`,
  content: `${PREFIX}-content`,
  icon: `${PREFIX}-icon`,
};

interface RootProps {
  color: string;
}

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'color',
})<RootProps>(({theme, color}) => ({
  position: 'relative',

  [`& .${classes.border}`]: {
    height: '100%',
    width: '100%',
    borderRadius: theme.spacing(2),
    border: `1px solid ${color}`,
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    opacity: 0.2,
    pointerEvents: 'none',
  },

  [`& .${classes.content}`]: {
    position: 'relative',
    zIndex: 0,
    display: 'flex',
  },

  [`& .${classes.icon}`]: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
  },
}));

export {classes as methodClasses, Root as WidgetMethodRoot};
